import Vue from 'vue';
import PhotoSwipe from 'vue-simple-photoswipe';
Vue.use(PhotoSwipe);
